import axios from 'axios';
import {BASE_URL} from '../environment/stores';

export default axios.create({
  baseURL: BASE_URL,
});